// import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import PrivateRoute from './utils/PrivateRoute';
import AdminRoute from './utils/AdminRoute';
import SuperAdminRoute from './utils/SuperAdminRoute';
import SettlementLayout from './components/SettlementLayout';
import PublicHomePage from './pages/public/PublicHomePage';
import PublicArtistListPage from './pages/public/PublicArtistListPage';
import PublicArtistDetailPage from './pages/public/PublicArtistDetailPage';
import PublicAlbumDetailPage from './pages/public/PublicAlbumDetailPage';
import PublicLatestSongsPage from './pages/public/PublicLatestSongsPage';
import PublicAlbumListPage from './pages/public/PublicAlbumListPage';
import PublicPlaylistPage from './pages/public/PublicPlaylistPage';
import PublicPlaylistDetailPage from './pages/public/PublicPlaylistDetailPage';
import PublicMusicTrendPage from './pages/public/PublicMusicTrendPage';
import PublicMusicTrendDetailPage from './pages/public/PublicMusicTrendDetailPage';
import PublicHotPlacePage from './pages/public/PublicHotPlacePage';
import PublicHotPlaceDetailPage from './pages/public/PublicHotPlaceDetailPage';
import PublicMusicVideoPage from './pages/public/PublicMusicVideoPage';
import PublicMusicVideoDetailPage from './pages/public/PublicMusicVideoDetailPage';
import PublicInquiryPage from './pages/public/PublicInquiryPage';
import PublicProposalPage from './pages/public/PublicProposalPage';
import PublicProposalViewPage from './pages/public/PublicProposalViewPage';
import PublicReviewPage from './pages/public/PublicReviewPage';
import PublicReviewWritePage from './pages/public/PublicReviewWritePage';
import PublicReviewViewPage from './pages/public/PublicReviewViewPage';
import PublicClientReviewViewPage from './pages/public/PublicClientReviewViewPage';
import PublicClientReviewModifyPage from './pages/public/PublicClientReviewModifyPage';
import PublicReviewModifyPage from './pages/public/PublicReviewModifyPage';
import PublicReviewPaymentSuccessPage from './pages/public/PublicReviewPaymentSuccessPage';
import PublicReviewPaymentFailPage from './pages/public/PublicReviewPaymentFailPage';
import PublicBoardListPage from './pages/public/PublicBoardListPage';
import PublicSupportPage from './pages/public/PublicSupportPage';
import PublicBoardViewPage from './pages/public/PublicBoardViewPage';
import PublicBoardWritePage from './pages/public/PublicBoardWritePage';
import PublicBoardModifyPage from './pages/public/PublicBoardModifyPage';
import MemberRegisterPage from './pages/public/MemberRegisterPage';
import MemberEditProfilePage from './pages/public/MemberEditProfilePage';
import AdminLayout from './components/AdminLayout';
import AdminMemberListPage from './pages/admin/AdminMemberListPage';
import AdminBulkMessagePage from './pages/admin/AdminBulkMessagePage';
import AdminPopupPage from './pages/admin/AdminPopupPage';
import AdminAccessLogPage from './pages/admin/AdminAccessLogPage';
import AdminPushNotificationPage from './pages/admin/AdminPushNotificationPage';
import AdminCardNewsPage from './pages/admin/AdminCardNewsPage';
import AdminImageEditPage from './pages/admin/AdminImageEditPage';
import AdminPromotionEmailPage from './pages/admin/AdminPromotionEmailPage';
import AdminPromotionManagePage from './pages/admin/AdminPromotionManagePage';
import AdminNoticeManagePage from './pages/admin/AdminNoticeManagePage';
import LoginPage from './pages/LoginPage';
import EditProfilePage from './pages/EditProfilePage';
import DashBoardPage from './pages/DashBoardPage';
import CatalogHealthPage from './pages/CatalogHealthPage';
import RevenueAnalysisPage from './pages/RevenueAnalysisPage';
import ByClientLatestMonthPage from './pages/ByClientLatestMonthPage';
import ByClientMonthAlbumsPage from './pages/ByClientMonthAlbumsPage';
import ByClientMonthSongsPage from './pages/ByClientMonthSongsPage';
import ByAlbumsPage from './pages/ByAlbumsPage';
import ByMonthAlbumsPage from './pages/ByMonthAlbumsPage';
import BySongsPage from './pages/BySongsPage';
import ByMonthSongsPage from './pages/ByMonthSongsPage';
import ByMonthPlatformsPage from './pages/ByMonthPlatformsPage';
import ByMonthArtistsPage from './pages/ByMonthArtistsPage';
import ByPhysicalMonthPage from './pages/ByPhysicalMonthPage';
import ByPhysicalTotalPage from './pages/ByPhysicalTotalPage';
import DistributorsPage from './pages/DistributorsPage';
import CarryoverPage from './pages/CarryoverPage';
import TaxInvoicePage from './pages/TaxInvoicePage';
import PromotionReportPage from './pages/PromotionReportPage';
import MyPromotionReportPage from './pages/MyPromotionReportPage';
import CashReceiptPage from './pages/CashReceiptPage';
import ClientsPage from './pages/ClientsPage';
import ClientWritePage from './pages/ClientWritePage';
import ClientViewPage from './pages/ClientViewPage';
import ClientModifyPage from './pages/ClientModifyPage';
import MonthlyUploadPage from './pages/MonthlyUploadPage';
import ArtistsPage from './pages/ArtistsPage';
import ArtistWritePage from './pages/ArtistWritePage';
import ArtistViewPage from './pages/ArtistViewPage';
import ArtistModifyPage from './pages/ArtistModifyPage';
import AlbumsPage from './pages/AlbumsPage';
import AlbumWritePage from './pages/AlbumWritePage';
import AlbumViewPage from './pages/AlbumViewPage';
import AlbumModifyPage from './pages/AlbumModifyPage';
import SongsPage from './pages/SongsPage';
import SongViewPage from './pages/SongViewPage';
import SongModifyPage from './pages/SongModifyPage';
import SongWritePage from './pages/SongWritePage';
import BigDataUploadPage from './pages/BigDataUploadPage';
import EmailToClientsPage from './pages/EmailToClientsPage';
import PhysicalAlbumsPage from './pages/PhysicalAlbumsPage';
import PhysicalAlbumWritePage from './pages/PhysicalAlbumWritePage';
import PhysicalAlbumViewPage from './pages/PhysicalAlbumViewPage';
import PhysicalAlbumModifyPage from './pages/PhysicalAlbumModifyPage';
import PhysicalUploadPage from './pages/PhysicalUploadPage';
import BoardListPage from './pages/board/ListPage';
import BoardWritePage from './pages/board/WritePage';
import BoardViewPage from './pages/board/ViewPage';
import BoardModifyPage from './pages/board/ModifyPage';
import ReviewPage from './pages/ReviewPage';
import ReviewWritePage from './pages/ReviewWritePage';
import ReviewModifyPage from './pages/ReviewModifyPage';
import ReviewViewPage from './pages/ReviewViewPage';
import NoAccessPage from './pages/NoAccessPage';
import YouTubeDownload from './pages/ytVideo/YouTubeDownload';
import Compose from './pages/ytVideo/Compose';
import UploadSchedule from './pages/ytVideo/UploadSchedule';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentFailPage from './pages/PaymentFailPage';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import useAccessLog from './hooks/useAccessLog';
import { axiosConfigSetting } from './utils/api';
import { MusicPlayerProvider } from './contexts/MusicPlayerContext';
import MusicPlayer from './components/MusicPlayer/MusicPlayer';
import PaperLayout from './components/paper/PaperLayout';
import PaperHomePage from './pages/paper/PaperHomePage';
import PaperWorkPage from './pages/paper/PaperWorkPage';
import PaperWorkDetailPage from './pages/paper/PaperWorkDetailPage';
import PaperContactPage from './pages/paper/PaperContactPage';
import PaperBlogPage from './pages/paper/PaperBlogPage';
import PaperBlogDetailPage from './pages/paper/PaperBlogDetailPage';
import PaperAdminWorkListPage from './pages/paper/admin/PaperAdminWorkListPage';
import PaperAdminWorkFormPage from './pages/paper/admin/PaperAdminWorkFormPage';
import PaperAdminServicePage from './pages/paper/admin/PaperAdminServicePage';
import PaperAdminPartnerPage from './pages/paper/admin/PaperAdminPartnerPage';
import PaperAdminMemberPage from './pages/paper/admin/PaperAdminMemberPage';
import PaperAdminBlogPage from './pages/paper/admin/PaperAdminBlogPage';
import PaperAdminLayoutListPage from './pages/paper/admin/PaperAdminLayoutListPage';
import PaperAdminAssetPage from './pages/paper/admin/PaperAdminAssetPage';
import PaperLayoutEditorPage from './pages/paper/admin/PaperLayoutEditorPage';
import PaperAdminBudgetPage from './pages/paper/admin/PaperAdminBudgetPage';
import PaperAdminItemsPage from './pages/paper/admin/PaperAdminItemsPage';
import PaperAdminInventoryPage from './pages/paper/admin/PaperAdminInventoryPage';
import PaperAdminRecruitPage from './pages/paper/admin/PaperAdminRecruitPage';
import PaperAdminBoardsPage from './pages/paper/admin/PaperAdminBoardsPage';
import PaperAdminTasksPage from './pages/paper/admin/PaperAdminTasksPage';
import PaperAdminTaskEditorPage from './pages/paper/admin/PaperAdminTaskEditorPage';
import PaperAdminLayout from './pages/paper/admin/PaperAdminLayout';
import PaperLayoutViewPage from './pages/paper/PaperLayoutViewPage';
import PaperGalleryPage from './pages/paper/PaperGalleryPage';
import PaperLoginPage from './pages/paper/PaperLoginPage';
import PaperRegisterPage from './pages/paper/PaperRegisterPage';
import PaperEditProfilePage from './pages/paper/PaperEditProfilePage';
import GlobalAlert from './components/GlobalAlert';
import { MessageProvider } from './contexts/MessageContext';
import DistLoginPage from './pages/DistLoginPage';
import KDistLandingPage from './pages/KDistLandingPage';

axiosConfigSetting();

const isPaperDomain =
  window.location.hostname === 'pinkpaper.kr' ||
  window.location.hostname === 'www.pinkpaper.kr' ||
  window.location.hostname.includes('pinkpaper');

const isPublicDomain =
  window.location.hostname === 'impink.co.kr' ||
  window.location.hostname === 'www.impink.co.kr' ||
  window.location.hostname === 'urpink.co.kr' ||
  window.location.hostname === 'www.urpink.co.kr' ||
  window.location.hostname === 'localhost' ||
  window.location.hostname === '100.68.115.13' ||
  window.location.hostname === '100.116.73.97';

// kdist.net 도메인 분기
const hostname = window.location.hostname;
const isKdistRoot = hostname === 'kdist.net' || hostname === 'www.kdist.net';
const isDistDomain =
  isKdistRoot ||
  (hostname.endsWith('.kdist.net') && hostname.split('.').length === 3);

const HIDE_PLAYER_PATHS = ['/no-access'];

function AppContent() {
  const { pathname } = useLocation();
  useAccessLog();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // kdist.net 루트 — 랜딩 페이지
  if (isKdistRoot) {
    return (
      <Routes>
        <Route path="*" element={<KDistLandingPage />} />
      </Routes>
    );
  }

  // *.kdist.net — 정산 SaaS 서브도메인
  if (isDistDomain) {
    return (
      <div className="text-sm sm:text-base">
        <Routes>
          <Route path="/login" element={<DistLoginPage />} />
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* 정산시스템 */}
          <Route element={<SettlementLayout />}>
            <Route element={<PrivateRoute />}>
              <Route path="/EditProfile" element={<EditProfilePage />} />
              <Route path="/dashboard" element={<DashBoardPage />} />
              <Route path="/catalog-health" element={<CatalogHealthPage />} />
              <Route path="/ByClientLatestMonth" element={<ByClientLatestMonthPage />} />
              <Route path="/ByClientMonthAlbums" element={<ByClientMonthAlbumsPage />} />
              <Route path="/ByClientMonthSongs" element={<ByClientMonthSongsPage />} />
              <Route path="/ByAlbums" element={<ByAlbumsPage />} />
              <Route path="/ByMonthAlbums" element={<ByMonthAlbumsPage />} />
              <Route path="/ByMonthSongs" element={<ByMonthSongsPage />} />
              <Route path="/BySongs" element={<BySongsPage />} />
              <Route path="/ByMonthArtists" element={<ByMonthArtistsPage />} />
              <Route path="/ByMonthPlatforms" element={<ByMonthPlatformsPage />} />
              <Route path="/ByPhysicalMonth" element={<ByPhysicalMonthPage />} />
              <Route path="/ByPhysicalTotal" element={<ByPhysicalTotalPage />} />
              <Route path="/super/distributors" element={<DistributorsPage />} />
              <Route path="/super/revenue-analysis" element={<RevenueAnalysisPage />} />
              <Route path="/super/catalog-health" element={<CatalogHealthPage />} />
              <Route path="/super/carryover" element={<CarryoverPage />} />
              <Route path="/super/tax-invoice" element={<TaxInvoicePage />} />
              <Route path="/super/promotion-report" element={<PromotionReportPage />} />
              <Route path="/super/promotion-manage" element={<AdminPromotionManagePage />} />

              <Route path="/super/promotion-email" element={<AdminPromotionEmailPage />} />
              <Route path="/promotion-report" element={<MyPromotionReportPage />} />
              {/* 현금영수증 — 팝빌 후불 비용 이슈로 비활성화 (2026-04-07) */}
              {/* <Route path="/super/cash-receipt" element={<CashReceiptPage />} /> */}
              <Route element={<AdminRoute />}>
                <Route path="/Clients" element={<ClientsPage />} />
                <Route path="/ClientWrite" element={<ClientWritePage />} />
                <Route path="/Clients/:id" element={<ClientViewPage />} />
                <Route path="/Clients/Modify/:id" element={<ClientModifyPage />} />
                <Route path="/MonthlyUpload" element={<MonthlyUploadPage />} />
                <Route path="/PhysicalUpload" element={<PhysicalUploadPage />} />
                <Route path="/notice-manage" element={<AdminNoticeManagePage />} />
                <Route path="/BigDataUpload" element={<BigDataUploadPage />} />
                <Route path="/EmailToClients" element={<EmailToClientsPage />} />
                <Route path="/Artists" element={<ArtistsPage />} />
                <Route path="/ArtistWrite" element={<ArtistWritePage />} />
                <Route path="/Artists/:id" element={<ArtistViewPage />} />
                <Route path="/Artist/Modify/:id" element={<ArtistModifyPage />} />
                <Route path="/Albums" element={<AlbumsPage />} />
                <Route path="/AlbumWrite" element={<AlbumWritePage />} />
                <Route path="/Albums/:id" element={<AlbumViewPage />} />
                <Route path="/Album/Modify/:id" element={<AlbumModifyPage />} />
                <Route path="/Songs" element={<SongsPage />} />
                <Route path="/Songs/:id" element={<SongViewPage />} />
                <Route path="/Song/Modify/:id" element={<SongModifyPage />} />
                <Route path="/songWrite" element={<SongWritePage />} />
                <Route path="/songWrite/:key" element={<SongWritePage />} />
                <Route path="/PhysicalAlbums" element={<PhysicalAlbumsPage />} />
                <Route path="/PhysicalAlbumWrite" element={<PhysicalAlbumWritePage />} />
                <Route path="/PhysicalAlbums/:id" element={<PhysicalAlbumViewPage />} />
                <Route path="/PhysicalAlbums/Modify/:id" element={<PhysicalAlbumModifyPage />} />
              </Route>
              <Route path="/Notice/List" element={<BoardListPage boardType="Notice" />} />
              <Route path="/Notice/Write" element={<BoardWritePage boardType="Notice" />} />
              <Route path="/Notice/View/:id" element={<BoardViewPage boardType="Notice" />} />
              <Route path="/Notice/Modify/:id" element={<BoardModifyPage boardType="Notice" />} />
              <Route path="/Free/List" element={<BoardListPage boardType="Free" />} />
              <Route path="/Free/Write" element={<BoardWritePage boardType="Free" />} />
              <Route path="/Free/View/:id" element={<BoardViewPage boardType="Free" />} />
              <Route path="/Free/Modify/:id" element={<BoardModifyPage boardType="Free" />} />
              <Route path="/CoWork/List" element={<BoardListPage boardType="CoWork" />} />
              <Route path="/CoWork/Write" element={<BoardWritePage boardType="CoWork" />} />
              <Route path="/CoWork/View/:id" element={<BoardViewPage boardType="CoWork" />} />
              <Route path="/CoWork/Modify/:id" element={<BoardModifyPage boardType="CoWork" />} />
              <Route path="/QnA/List" element={<BoardListPage boardType="QnA" />} />
              <Route path="/QnA/Write" element={<BoardWritePage boardType="QnA" />} />
              <Route path="/QnA/View/:id" element={<BoardViewPage boardType="QnA" />} />
              <Route path="/QnA/Modify/:id" element={<BoardModifyPage boardType="QnA" />} />
            </Route>
            <Route path="/ReviewWritePage" element={<ReviewWritePage />} />
            <Route path="/ReviewPage" element={<ReviewPage />} />
            <Route path="/ReviewModifyPage/:id" element={<ReviewModifyPage />} />
            <Route path="/ReviewViewPage/:id" element={<ReviewViewPage />} />
            <Route path="/YouTubeDownload" element={<YouTubeDownload />} />
            <Route path="/Compose" element={<Compose />} />
            <Route path="/UploadSchedule" element={<UploadSchedule />} />
          </Route>

          <Route path="/no-access" element={<NoAccessPage />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    );
  }

  // 핑크페이퍼 도메인
  if (isPaperDomain) {
    return (
      <div className="text-sm sm:text-base">
        <Routes>
          <Route element={<PaperLayout />}>
            <Route path="/" element={<PaperHomePage />} />
            <Route path="/festival" element={<PaperWorkPage category="FESTIVAL" />} />
            <Route path="/event" element={<PaperWorkPage category="EVENT" />} />
            <Route path="/work/:id" element={<PaperWorkDetailPage />} />
            <Route path="/blog" element={<PaperBlogPage />} />
            <Route path="/blog/:id" element={<PaperBlogDetailPage />} />
            <Route path="/gallery" element={<PaperGalleryPage />} />
            <Route path="/contact" element={<PaperContactPage />} />
            <Route path="/mypage" element={<PaperEditProfilePage />} />
            <Route path="/login" element={<PaperLoginPage />} />
            <Route path="/register" element={<PaperRegisterPage />} />
            <Route path="/admin" element={<Navigate to="/admin/members" replace />} />
            <Route path="/admin/members" element={<PaperAdminMemberPage />} />
            <Route path="/admin/works" element={<PaperAdminWorkListPage />} />
            <Route path="/admin/works/new" element={<PaperAdminWorkFormPage />} />
            <Route path="/admin/works/:id/edit" element={<PaperAdminWorkFormPage />} />
            <Route path="/admin/services" element={<PaperAdminServicePage />} />
            <Route path="/admin/partners" element={<PaperAdminPartnerPage />} />
            <Route path="/admin/blogs" element={<PaperAdminBlogPage />} />
            <Route path="/admin/tasks" element={<PaperAdminBoardsPage />} />
            <Route path="/admin/tasks/:boardId" element={<PaperAdminTasksPage />} />
            <Route path="/admin/tasks/:boardId/:taskId" element={<PaperAdminTaskEditorPage />} />
            <Route path="/recruit" element={<PaperAdminRecruitPage />} />
          </Route>
          {/* 행사배치도 (메인 메뉴, PaperLayout 안) */}
          <Route element={<PaperLayout />}>
            <Route path="/layouts" element={<PaperAdminLayoutListPage />} />
            <Route path="/layouts/assets" element={<PaperAdminAssetPage />} />
          </Route>
          {/* 배치도 에디터 / 예산관리 / 렌탈관리 / 물품관리 (전체화면, PaperLayout 밖) */}
          <Route path="/layouts/:id/edit" element={<PaperLayoutEditorPage />} />
          <Route path="/layouts/share/:shareId" element={<PaperLayoutEditorPage />} />
          <Route element={<AdminRoute />}>
            <Route path="/layouts/:id/budget" element={<PaperAdminBudgetPage />} />
            <Route path="/layouts/:id/items" element={<PaperAdminItemsPage />} />
            <Route path="/layouts/:id/inventory" element={<PaperAdminInventoryPage />} />
          </Route>
          <Route path="/layout/:shareId" element={<PaperLayoutViewPage />} />
        </Routes>
      </div>
    );
  }

  if (isPublicDomain) {
    return (
      <div className="text-sm sm:text-base">
        <Routes>
          {/* 퍼블릭 페이지 (루트 경로) — caseSensitive로 정산사이트 /Songs, /Albums, /Artists와 충돌 방지 */}
          <Route path="/" element={<PublicHomePage />} />
          <Route path="/songs" caseSensitive element={<PublicLatestSongsPage />} />
          <Route path="/albums" caseSensitive element={<PublicAlbumListPage />} />
          <Route path="/artists" caseSensitive element={<PublicArtistListPage />} />
          <Route path="/artists/:id" caseSensitive element={<PublicArtistDetailPage />} />
          <Route path="/albums/:id" caseSensitive element={<PublicAlbumDetailPage />} />
          <Route path="/playlists" element={<PublicPlaylistPage />} />
          <Route path="/playlists/:id" element={<PublicPlaylistDetailPage />} />
          <Route path="/music-trends" element={<Navigate to="/magazine/music-trends" replace />} />
          <Route path="/music-trends/:id" element={<PublicMusicTrendDetailPage />} />
          <Route path="/magazine/music-trends" element={<PublicMusicTrendPage />} />
          <Route path="/magazine/music-trends/:id" element={<PublicMusicTrendDetailPage />} />
          <Route path="/magazine/hot-place" element={<PublicHotPlacePage />} />
          <Route path="/magazine/hot-place/:id" element={<PublicHotPlaceDetailPage />} />
          <Route path="/music-videos" element={<PublicMusicVideoPage />} />
          <Route path="/music-videos/:id" element={<PublicMusicVideoDetailPage />} />
          <Route path="/inquiry" element={<PublicInquiryPage />} />
          <Route path="/proposal" element={<PublicProposalPage />} />
          <Route path="/proposal/:id" element={<PublicProposalViewPage />} />
          <Route path="/review" element={<PublicReviewPage />} />
          <Route path="/review/write" element={<PublicReviewWritePage />} />
          <Route path="/review/client-apply/:id" element={<PublicClientReviewViewPage />} />
          <Route path="/client-review/:id/edit" element={<PublicClientReviewModifyPage />} />
          <Route path="/client-review/:id" element={<PublicClientReviewViewPage />} />
          <Route path="/review/:id" element={<PublicReviewViewPage />} />
          <Route path="/review/:id/edit" element={<PublicReviewModifyPage />} />
          <Route path="/review/payment/success" element={<PublicReviewPaymentSuccessPage />} />
          <Route path="/review/payment/fail" element={<PublicReviewPaymentFailPage />} />
          <Route path="/community/notice" element={<PublicBoardListPage boardType="PNotice" />} />
          <Route path="/community/notice/view/:id" element={<PublicBoardViewPage boardType="PNotice" />} />
          <Route path="/community/notice/write" element={<PublicBoardWritePage boardType="PNotice" />} />
          <Route path="/community/notice/modify/:id" element={<PublicBoardModifyPage boardType="PNotice" />} />
          <Route path="/community/news" element={<Navigate to="/community/notice" replace />} />
          <Route path="/community/support" element={<PublicSupportPage />} />
          <Route path="/community/free" element={<PublicBoardListPage boardType="PFree" />} />
          <Route path="/community/free/view/:id" element={<PublicBoardViewPage boardType="PFree" />} />
          <Route path="/community/free/write" element={<PublicBoardWritePage boardType="PFree" />} />
          <Route path="/community/free/modify/:id" element={<PublicBoardModifyPage boardType="PFree" />} />
          <Route path="/register" element={<MemberRegisterPage />} />
          <Route path="/mypage" element={<MemberEditProfilePage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* 관리자 페이지 (AdminLayout 적용) */}
          <Route element={<AdminLayout />}>
            <Route element={<AdminRoute />}>
              <Route path="/admin/members" element={<AdminMemberListPage />} />
              <Route path="/admin/messages" element={<AdminBulkMessagePage />} />
              <Route path="/admin/popups" element={<AdminPopupPage />} />
              <Route path="/admin/access-logs" element={<AdminAccessLogPage />} />
              <Route path="/admin/image-edit" element={<AdminImageEditPage />} />
              <Route path="/admin/push-notifications" element={<AdminPushNotificationPage />} />
              <Route path="/admin/card-news" element={<AdminCardNewsPage />} />
            </Route>
          </Route>

          {/* 정산시스템 (SettlementLayout 적용) */}
          <Route element={<SettlementLayout />}>
            <Route element={<PrivateRoute />}>
              <Route path="/EditProfile" element={<EditProfilePage />} />
              <Route path="/dashboard" element={<DashBoardPage />} />
              <Route path="/catalog-health" element={<CatalogHealthPage />} />
              <Route path="/ByClientLatestMonth" element={<ByClientLatestMonthPage />} />
              <Route path="/ByClientMonthAlbums" element={<ByClientMonthAlbumsPage />} />
              <Route path="/ByClientMonthSongs" element={<ByClientMonthSongsPage />} />
              <Route path="/ByAlbums" element={<ByAlbumsPage />} />
              <Route path="/ByMonthAlbums" element={<ByMonthAlbumsPage />} />
              <Route path="/ByMonthSongs" element={<ByMonthSongsPage />} />
              <Route path="/BySongs" element={<BySongsPage />} />
              <Route path="/ByMonthArtists" element={<ByMonthArtistsPage />} />
              <Route path="/ByMonthPlatforms" element={<ByMonthPlatformsPage />} />
              <Route path="/ByPhysicalMonth" element={<ByPhysicalMonthPage />} />
              <Route path="/ByPhysicalTotal" element={<ByPhysicalTotalPage />} />
              <Route path="/super/distributors" element={<DistributorsPage />} />
              <Route path="/super/revenue-analysis" element={<RevenueAnalysisPage />} />
              <Route path="/super/catalog-health" element={<CatalogHealthPage />} />
              <Route path="/super/carryover" element={<CarryoverPage />} />
              <Route path="/super/tax-invoice" element={<TaxInvoicePage />} />
              <Route path="/super/promotion-report" element={<PromotionReportPage />} />
              <Route path="/super/promotion-manage" element={<AdminPromotionManagePage />} />

              <Route path="/super/promotion-email" element={<AdminPromotionEmailPage />} />
              <Route path="/promotion-report" element={<MyPromotionReportPage />} />
              {/* 현금영수증 — 팝빌 후불 비용 이슈로 비활성화 (2026-04-07) */}
              {/* <Route path="/super/cash-receipt" element={<CashReceiptPage />} /> */}
              <Route element={<AdminRoute />}>
                <Route path="/Clients" element={<ClientsPage />} />
                <Route path="/ClientWrite" element={<ClientWritePage />} />
                <Route path="/Clients/:id" element={<ClientViewPage />} />
                <Route path="/Clients/Modify/:id" element={<ClientModifyPage />} />
                <Route path="/MonthlyUpload" element={<MonthlyUploadPage />} />
                <Route path="/PhysicalUpload" element={<PhysicalUploadPage />} />
                <Route path="/EmailToClients" element={<EmailToClientsPage />} />
                <Route path="/Artists" element={<ArtistsPage />} />
                <Route path="/ArtistWrite" element={<ArtistWritePage />} />
                <Route path="/Artists/:id" element={<ArtistViewPage />} />
                <Route path="/Artists/Modify/:id" element={<ArtistModifyPage />} />
                <Route path="/Albums" element={<AlbumsPage />} />
                <Route path="/AlbumWrite" element={<AlbumWritePage />} />
                <Route path="/Albums/:id" element={<AlbumViewPage />} />
                <Route path="/Album/Modify/:id" element={<AlbumModifyPage />} />
                <Route path="/Songs" element={<SongsPage />} />
                <Route path="/Songs/:id" element={<SongViewPage />} />
                <Route path="/Song/Modify/:id" element={<SongModifyPage />} />
                <Route path="/songWrite" element={<SongWritePage />} />
                <Route path="/songWrite/:key" element={<SongWritePage />} />
                <Route path="/notice-manage" element={<AdminNoticeManagePage />} />
                <Route path="/BigDataUpload" element={<BigDataUploadPage />} />
                <Route path="/PhysicalAlbums" element={<PhysicalAlbumsPage />} />
                <Route path="/PhysicalAlbumWrite" element={<PhysicalAlbumWritePage />} />
                <Route path="/PhysicalAlbums/:id" element={<PhysicalAlbumViewPage />} />
                <Route path="/PhysicalAlbums/Modify/:id" element={<PhysicalAlbumModifyPage />} />
              </Route>
              <Route path="/Notice/List" element={<BoardListPage boardType="Notice" />} />
              <Route path="/Notice/Write" element={<BoardWritePage boardType="Notice" />} />
              <Route path="/Notice/View/:id" element={<BoardViewPage boardType="Notice" />} />
              <Route path="/Notice/Modify/:id" element={<BoardModifyPage boardType="Notice" />} />
              <Route path="/Free/List" element={<BoardListPage boardType="Free" />} />
              <Route path="/Free/Write" element={<BoardWritePage boardType="Free" />} />
              <Route path="/Free/View/:id" element={<BoardViewPage boardType="Free" />} />
              <Route path="/Free/Modify/:id" element={<BoardModifyPage boardType="Free" />} />
              <Route path="/CoWork/List" element={<BoardListPage boardType="CoWork" />} />
              <Route path="/CoWork/Write" element={<BoardWritePage boardType="CoWork" />} />
              <Route path="/CoWork/View/:id" element={<BoardViewPage boardType="CoWork" />} />
              <Route path="/CoWork/Modify/:id" element={<BoardModifyPage boardType="CoWork" />} />
              <Route path="/QnA/List" element={<BoardListPage boardType="QnA" />} />
              <Route path="/QnA/Write" element={<BoardWritePage boardType="QnA" />} />
              <Route path="/QnA/View/:id" element={<BoardViewPage boardType="QnA" />} />
              <Route path="/QnA/Modify/:id" element={<BoardModifyPage boardType="QnA" />} />
            </Route>
            <Route path="/ReviewWritePage" element={<ReviewWritePage />} />
            <Route path="/ReviewPage" element={<ReviewPage />} />
            <Route path="/ReviewModifyPage/:id" element={<ReviewModifyPage />} />
            <Route path="/ReviewViewPage/:id" element={<ReviewViewPage />} />
            <Route path="/YouTubeDownload" element={<YouTubeDownload />} />
            <Route path="/Compose" element={<Compose />} />
            <Route path="/UploadSchedule" element={<UploadSchedule />} />
          </Route>

          <Route path="/payment" element={<PaymentSuccessPage />} />
          <Route path="/payment/fail" element={<PaymentFailPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />

          {/* 핑크페이퍼 (/paper/*) */}
          <Route path="/paper" element={<PaperLayout />}>
            <Route index element={<PaperHomePage />} />
            <Route path="festival" element={<PaperWorkPage category="FESTIVAL" />} />
            <Route path="event" element={<PaperWorkPage category="EVENT" />} />
            <Route path="work/:id" element={<PaperWorkDetailPage />} />
            <Route path="blog" element={<PaperBlogPage />} />
            <Route path="blog/:id" element={<PaperBlogDetailPage />} />
            <Route path="gallery" element={<PaperGalleryPage />} />
            <Route path="contact" element={<PaperContactPage />} />
            <Route path="mypage" element={<PaperEditProfilePage />} />
            <Route path="login" element={<PaperLoginPage />} />
            <Route path="register" element={<PaperRegisterPage />} />
            <Route path="admin" element={<Navigate to="/paper/admin/members" replace />} />
            <Route path="admin/members" element={<PaperAdminMemberPage />} />
            <Route path="admin/works" element={<PaperAdminWorkListPage />} />
            <Route path="admin/works/new" element={<PaperAdminWorkFormPage />} />
            <Route path="admin/works/:id/edit" element={<PaperAdminWorkFormPage />} />
            <Route path="admin/services" element={<PaperAdminServicePage />} />
            <Route path="admin/partners" element={<PaperAdminPartnerPage />} />
            <Route path="admin/blogs" element={<PaperAdminBlogPage />} />
            <Route path="admin/tasks" element={<PaperAdminBoardsPage />} />
            <Route path="admin/tasks/:boardId" element={<PaperAdminTasksPage />} />
            <Route path="admin/tasks/:boardId/:taskId" element={<PaperAdminTaskEditorPage />} />
            <Route path="recruit" element={<PaperAdminRecruitPage />} />
          </Route>
          {/* 행사배치도 (메인 메뉴, PaperLayout 안) */}
          <Route element={<PaperLayout />}>
            <Route path="paper/layouts" element={<PaperAdminLayoutListPage />} />
            <Route path="paper/layouts/assets" element={<PaperAdminAssetPage />} />
          </Route>
          {/* 배치도 에디터 / 예산관리 / 렌탈관리 / 물품관리 (전체화면) */}
          <Route path="/paper/layouts/:id/edit" element={<PaperLayoutEditorPage />} />
          <Route path="/paper/layouts/share/:shareId" element={<PaperLayoutEditorPage />} />
          <Route element={<AdminRoute />}>
            <Route path="/paper/layouts/:id/budget" element={<PaperAdminBudgetPage />} />
            <Route path="/paper/layouts/:id/items" element={<PaperAdminItemsPage />} />
            <Route path="/paper/layouts/:id/inventory" element={<PaperAdminInventoryPage />} />
          </Route>
          <Route path="/paper/layout/:shareId" element={<PaperLayoutViewPage />} />
        </Routes>
        {!pathname.startsWith('/paper') && <MusicPlayer />}
      </div>
    );
  }

  const showPlayer = !HIDE_PLAYER_PATHS.includes(pathname) && !pathname.startsWith('/paper');
  return (
    <div className="text-sm sm:text-base">
      <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/no-access" element={<NoAccessPage />} />

          {/* 루트 → 퍼블릭 홈으로 리다이렉트 */}
          <Route path="/" element={<Navigate to="/public" replace />} />

          {/* 공개 홈페이지 (/public/*) */}
          <Route path="/public" element={<PublicHomePage />} />
          <Route path="/public/songs" element={<PublicLatestSongsPage />} />
          <Route path="/public/albums" element={<PublicAlbumListPage />} />
          <Route path="/public/artists" element={<PublicArtistListPage />} />
          <Route path="/public/artists/:id" element={<PublicArtistDetailPage />} />
          <Route path="/public/albums/:id" element={<PublicAlbumDetailPage />} />
          <Route path="/public/playlists" element={<PublicPlaylistPage />} />
          <Route path="/public/playlists/:id" element={<PublicPlaylistDetailPage />} />
          <Route path="/public/music-trends" element={<Navigate to="/public/magazine/music-trends" replace />} />
          <Route path="/public/music-trends/:id" element={<PublicMusicTrendDetailPage />} />
          <Route path="/public/magazine/music-trends" element={<PublicMusicTrendPage />} />
          <Route path="/public/magazine/music-trends/:id" element={<PublicMusicTrendDetailPage />} />
          <Route path="/public/magazine/hot-place" element={<PublicHotPlacePage />} />
          <Route path="/public/magazine/hot-place/:id" element={<PublicHotPlaceDetailPage />} />
          <Route path="/public/music-videos" element={<PublicMusicVideoPage />} />
          <Route path="/public/music-videos/:id" element={<PublicMusicVideoDetailPage />} />
          <Route path="/public/inquiry" element={<PublicInquiryPage />} />
          <Route path="/public/proposal" element={<PublicProposalPage />} />
          <Route path="/public/proposal/:id" element={<PublicProposalViewPage />} />
          <Route path="/public/review" element={<PublicReviewPage />} />
          <Route path="/public/review/write" element={<PublicReviewWritePage />} />
          <Route path="/public/review/client-apply/:id" element={<PublicClientReviewViewPage />} />
          <Route path="/public/client-review/:id/edit" element={<PublicClientReviewModifyPage />} />
          <Route path="/public/client-review/:id" element={<PublicClientReviewViewPage />} />
          <Route path="/public/review/:id" element={<PublicReviewViewPage />} />
          <Route path="/public/review/:id/edit" element={<PublicReviewModifyPage />} />
          <Route path="/public/review/payment/success" element={<PublicReviewPaymentSuccessPage />} />
          <Route path="/public/review/payment/fail" element={<PublicReviewPaymentFailPage />} />
          <Route path="/public/community/notice" element={<PublicBoardListPage boardType="PNotice" />} />
          <Route path="/public/community/notice/view/:id" element={<PublicBoardViewPage boardType="PNotice" />} />
          <Route path="/public/community/notice/write" element={<PublicBoardWritePage boardType="PNotice" />} />
          <Route path="/public/community/notice/modify/:id" element={<PublicBoardModifyPage boardType="PNotice" />} />
          <Route path="/public/community/news" element={<Navigate to="/public/community/notice" replace />} />
          <Route path="/public/community/support" element={<PublicSupportPage />} />
          <Route path="/public/community/free" element={<PublicBoardListPage boardType="PFree" />} />
          <Route path="/public/community/free/view/:id" element={<PublicBoardViewPage boardType="PFree" />} />
          <Route path="/public/community/free/write" element={<PublicBoardWritePage boardType="PFree" />} />
          <Route path="/public/community/free/modify/:id" element={<PublicBoardModifyPage boardType="PFree" />} />
          <Route path="/public/register" element={<MemberRegisterPage />} />
          <Route path="/public/mypage" element={<MemberEditProfilePage />} />
          <Route path="/public/login" element={<LoginPage />} />

          {/* 관리자 페이지 (AdminLayout 적용) */}
          <Route element={<AdminLayout />}>
            <Route element={<AdminRoute />}>
              <Route path="/public/admin/members" element={<AdminMemberListPage />} />
              <Route path="/public/admin/messages" element={<AdminBulkMessagePage />} />
              <Route path="/public/admin/popups" element={<AdminPopupPage />} />
              <Route path="/public/admin/access-logs" element={<AdminAccessLogPage />} />
              <Route path="/public/admin/image-edit" element={<AdminImageEditPage />} />
              <Route path="/public/admin/push-notifications" element={<AdminPushNotificationPage />} />
              <Route path="/public/admin/card-news" element={<AdminCardNewsPage />} />
            </Route>
          </Route>

          {/* 정산사이트 (SettlementLayout 적용) */}
          <Route element={<SettlementLayout />}>
            <Route element={<PrivateRoute />}>
              <Route path="/EditProfile" element={<EditProfilePage />} />
              <Route path="/dashboard" element={<DashBoardPage />} />
              <Route path="/catalog-health" element={<CatalogHealthPage />} />
              <Route path="/ByClientLatestMonth" element={<ByClientLatestMonthPage />} />
              <Route path="/ByClientMonthAlbums" element={<ByClientMonthAlbumsPage />} />
              <Route path="/ByClientMonthSongs" element={<ByClientMonthSongsPage />} />
              <Route path="/ByAlbums" element={<ByAlbumsPage />} />
              <Route path="/ByMonthAlbums" element={<ByMonthAlbumsPage />} />
              <Route path="/ByMonthSongs" element={<ByMonthSongsPage />} />
              <Route path="/BySongs" element={<BySongsPage />} />
              <Route path="/ByMonthArtists" element={<ByMonthArtistsPage />} />
              <Route path="/ByMonthPlatforms" element={<ByMonthPlatformsPage />} />
              <Route path="/ByPhysicalMonth" element={<ByPhysicalMonthPage />} />
              <Route path="/ByPhysicalTotal" element={<ByPhysicalTotalPage />} />
              <Route path="/super/distributors" element={<DistributorsPage />} />
              <Route path="/super/revenue-analysis" element={<RevenueAnalysisPage />} />
              <Route path="/super/catalog-health" element={<CatalogHealthPage />} />
              <Route path="/super/carryover" element={<CarryoverPage />} />
              <Route path="/super/tax-invoice" element={<TaxInvoicePage />} />
              <Route path="/super/promotion-report" element={<PromotionReportPage />} />
              <Route path="/super/promotion-manage" element={<AdminPromotionManagePage />} />

              <Route path="/super/promotion-email" element={<AdminPromotionEmailPage />} />
              <Route path="/promotion-report" element={<MyPromotionReportPage />} />
              {/* 현금영수증 — 팝빌 후불 비용 이슈로 비활성화 (2026-04-07) */}
              {/* <Route path="/super/cash-receipt" element={<CashReceiptPage />} /> */}

              {/* 관리자 전용 */}
              <Route element={<AdminRoute />}>
                <Route path="/Clients" element={<ClientsPage />} />
                <Route path="/ClientWrite" element={<ClientWritePage />} />
                <Route path="/Clients/:id" element={<ClientViewPage />} />
                <Route path="/Clients/Modify/:id" element={<ClientModifyPage />} />
                <Route path="/MonthlyUpload" element={<MonthlyUploadPage />} />
                <Route path="/PhysicalUpload" element={<PhysicalUploadPage />} />
                <Route path="/EmailToClients" element={<EmailToClientsPage />} />
                <Route path="/Artists" element={<ArtistsPage />} />
                <Route path="/ArtistWrite" element={<ArtistWritePage />} />
                <Route path="/Artists/:id" element={<ArtistViewPage />} />
                <Route path="/Artists/Modify/:id" element={<ArtistModifyPage />} />
                <Route path="/Albums" element={<AlbumsPage />} />
                <Route path="/AlbumWrite" element={<AlbumWritePage />} />
                <Route path="/Albums/:id" element={<AlbumViewPage />} />
                <Route path="/Album/Modify/:id" element={<AlbumModifyPage />} />
                <Route path="/Songs" element={<SongsPage />} />
                <Route path="/Songs/:id" element={<SongViewPage />} />
                <Route path="/Song/Modify/:id" element={<SongModifyPage />} />
                <Route path="/songWrite" element={<SongWritePage />} />
                <Route path="/songWrite/:key" element={<SongWritePage />} />
                <Route path="/notice-manage" element={<AdminNoticeManagePage />} />
                <Route path="/BigDataUpload" element={<BigDataUploadPage />} />
                <Route path="/PhysicalAlbums" element={<PhysicalAlbumsPage />} />
                <Route path="/PhysicalAlbumWrite" element={<PhysicalAlbumWritePage />} />
                <Route path="/PhysicalAlbums/:id" element={<PhysicalAlbumViewPage />} />
                <Route path="/PhysicalAlbums/Modify/:id" element={<PhysicalAlbumModifyPage />} />
              </Route>

              {/* 게시판 */}
              <Route path="/Notice/List" element={<BoardListPage boardType="Notice" />} />
              <Route path="/Notice/Write" element={<BoardWritePage boardType="Notice" />} />
              <Route path="/Notice/View/:id" element={<BoardViewPage boardType="Notice" />} />
              <Route path="/Notice/Modify/:id" element={<BoardModifyPage boardType="Notice" />} />
              <Route path="/Free/List" element={<BoardListPage boardType="Free" />} />
              <Route path="/Free/Write" element={<BoardWritePage boardType="Free" />} />
              <Route path="/Free/View/:id" element={<BoardViewPage boardType="Free" />} />
              <Route path="/Free/Modify/:id" element={<BoardModifyPage boardType="Free" />} />
              <Route path="/CoWork/List" element={<BoardListPage boardType="CoWork" />} />
              <Route path="/CoWork/Write" element={<BoardWritePage boardType="CoWork" />} />
              <Route path="/CoWork/View/:id" element={<BoardViewPage boardType="CoWork" />} />
              <Route path="/CoWork/Modify/:id" element={<BoardModifyPage boardType="CoWork" />} />
              <Route path="/QnA/List" element={<BoardListPage boardType="QnA" />} />
              <Route path="/QnA/Write" element={<BoardWritePage boardType="QnA" />} />
              <Route path="/QnA/View/:id" element={<BoardViewPage boardType="QnA" />} />
              <Route path="/QnA/Modify/:id" element={<BoardModifyPage boardType="QnA" />} />
            </Route>

            {/* 방송심의 (로그인 불필요) */}
            <Route path="/ReviewWritePage" element={<ReviewWritePage />} />
            <Route path="/ReviewPage" element={<ReviewPage />} />
            <Route path="/ReviewModifyPage/:id" element={<ReviewModifyPage />} />
            <Route path="/ReviewViewPage/:id" element={<ReviewViewPage />} />

            {/* 유튜브 프로젝트 */}
            <Route path="/YouTubeDownload" element={<YouTubeDownload />} />
            <Route path="/Compose" element={<Compose />} />
            <Route path="/UploadSchedule" element={<UploadSchedule />} />
          </Route>

          {/* 결제 */}
          <Route path="/payment" element={<PaymentSuccessPage />} />
          <Route path="/payment/fail" element={<PaymentFailPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />

          {/* 핑크페이퍼 (/paper/*) */}
          <Route path="/paper" element={<PaperLayout />}>
            <Route index element={<PaperHomePage />} />
            <Route path="festival" element={<PaperWorkPage category="FESTIVAL" />} />
            <Route path="event" element={<PaperWorkPage category="EVENT" />} />
            <Route path="work/:id" element={<PaperWorkDetailPage />} />
            <Route path="blog" element={<PaperBlogPage />} />
            <Route path="blog/:id" element={<PaperBlogDetailPage />} />
            <Route path="gallery" element={<PaperGalleryPage />} />
            <Route path="contact" element={<PaperContactPage />} />
            <Route path="mypage" element={<PaperEditProfilePage />} />
            <Route path="login" element={<PaperLoginPage />} />
            <Route path="register" element={<PaperRegisterPage />} />
            <Route path="admin" element={<Navigate to="/paper/admin/members" replace />} />
            <Route path="admin/members" element={<PaperAdminMemberPage />} />
            <Route path="admin/works" element={<PaperAdminWorkListPage />} />
            <Route path="admin/works/new" element={<PaperAdminWorkFormPage />} />
            <Route path="admin/works/:id/edit" element={<PaperAdminWorkFormPage />} />
            <Route path="admin/services" element={<PaperAdminServicePage />} />
            <Route path="admin/partners" element={<PaperAdminPartnerPage />} />
            <Route path="admin/blogs" element={<PaperAdminBlogPage />} />
            <Route path="admin/tasks" element={<PaperAdminBoardsPage />} />
            <Route path="admin/tasks/:boardId" element={<PaperAdminTasksPage />} />
            <Route path="admin/tasks/:boardId/:taskId" element={<PaperAdminTaskEditorPage />} />
            <Route path="recruit" element={<PaperAdminRecruitPage />} />
          </Route>
          {/* 행사배치도 (메인 메뉴, PaperLayout 안) */}
          <Route element={<PaperLayout />}>
            <Route path="paper/layouts" element={<PaperAdminLayoutListPage />} />
            <Route path="paper/layouts/assets" element={<PaperAdminAssetPage />} />
          </Route>
          {/* 배치도 에디터 / 예산관리 / 렌탈관리 / 물품관리 (전체화면) */}
          <Route path="/paper/layouts/:id/edit" element={<PaperLayoutEditorPage />} />
          <Route path="/paper/layouts/share/:shareId" element={<PaperLayoutEditorPage />} />
          <Route element={<AdminRoute />}>
            <Route path="/paper/layouts/:id/budget" element={<PaperAdminBudgetPage />} />
            <Route path="/paper/layouts/:id/items" element={<PaperAdminItemsPage />} />
            <Route path="/paper/layouts/:id/inventory" element={<PaperAdminInventoryPage />} />
          </Route>
          <Route path="/paper/layout/:shareId" element={<PaperLayoutViewPage />} />
      </Routes>
      {showPlayer && <MusicPlayer />}
    </div>
  );
}

function App() {
  return (
    <MusicPlayerProvider>
      <Router>
        <MessageProvider>
          <AppContent />
        </MessageProvider>
      </Router>
      <GlobalAlert />
    </MusicPlayerProvider>
  );
}

export default App;
